import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import Select from './SelectInput';
import Table from './Table';
import ConsumoTotal from './ConsumoTotal';
import CallToAction from '../CallToAction';

class CalculadoraConsumo extends Component {
  state = { selected: [], options: this.props.equipos };

  onSelectOption = option => {
    const { selected, options = [] } = this.state;
    const newSelected = [...selected];

    newSelected.push(option);

    const newOptions = options.filter(item => {
      const itemName = item.selectedOption ? item.selectedOption.nombre : item.nombre;
      const optionName = option.selectedOption ? option.selectedOption.nombre : option.nombre;
      return itemName !== optionName;
    });
    return new Promise((resolve, reject) =>
      this.setState({ selected: newSelected, options: newOptions }, resolve())
    );
  };

  onRemoveOption = option => {
    const { selected, options = [] } = this.state;
    const newSelected = selected.filter(item => {
      const { selectedOption, nombre } = item;
      const itemName = selectedOption ? selectedOption.nombre : nombre;
      const optionName = option.selectedOption ? option.selectedOption.nombre : option.nombre;
      return itemName !== optionName;
    });

    const isFromList = !!option.cover;
    const newOptions = isFromList ? [...options, option] : [...options];

    return new Promise((resolve, reject) =>
      this.setState({ selected: newSelected, options: newOptions }, resolve())
    );
  };

  render() {
    const { selected, options = [] } = this.state;
    return (
      <section id="about" className="g-pt-100">
        <div className="container text-center g-max-width-750 g-mb-70">
          <div className="text-uppercase u-heading-v2-4--bottom g-brd-primary">
            <h3 className="h3 g-letter-spacing-5 g-font-size-12 g-font-weight-400 g-color-primary g-mb-25">
              Sistema Solar
            </h3>
            <h2 className="u-heading-v2__title g-line-height-1 g-letter-spacing-2 g-font-size-30 g-font-size-40--md mb-0">
              Calcula tu consumo
            </h2>
          </div>
        </div>
        <Container>
          <Row>
            <Col xs={12} sm={6} md={6}>
              <Select options={options} onSelect={this.onSelectOption} />
            </Col>
            <Col xs={12} sm={6} md={6}>
              <ConsumoTotal selected={selected} />
            </Col>
          </Row>
        </Container>
        <Container className="g-pb-100--md" style={{ marginTop: '3rem' }}>
          {selected.length === 0 && (
            <div style={{ textAlign: 'center' }}>
              <h4>Selecciona tus artefactos</h4>
            </div>
          )}
          {selected.length > 0 && <Table rows={selected} onRemove={this.onRemoveOption} />}
        </Container>

        <CallToAction selected={selected} />
      </section>
    );
  }
}
export default CalculadoraConsumo;



// WEBPACK FOOTER //
// ./src/components/Home/CalculadoraConsumo/index.js